module.exports = __webpack_public_path__ + "media/images/icons/menu-close-e44ec8da7cf24aee4375b4504181b4c8.svg";